import AuthService from '../../utilities/services/auth.service'
import { PricingLevelPerformanceWrapper } from '../../components'

export default function PricingLevelPerformancePage() {
  const organization = AuthService.getOrg()[0]

  return <PricingLevelPerformanceWrapper organization={organization} />
}
